import { FC } from 'react'
import { Divider } from 'antd'
import { useAppSelector } from '../../store/hooks'
import { EUserRole } from '../../constants/approval'
import { LogoGreenETrack } from '../../assets/icons'

import {
    Navigation,
    UserPanel,
    AdminNavigation,
    ExternalNavigation,
    LanguageMenu,
    MobileGuestMenu,
} from './components'
import style from './style.m.less'
import { Link } from 'react-router-dom'

interface IHeader {
    isUnread: boolean
    isAuth: boolean
}

const Header: FC<IHeader> = ({ isUnread, isAuth }) => {
    const isUserLoading = useAppSelector((state) => state.user.isLoading)

    const userRole = useAppSelector((state) => state.user.data.user_role)

    const isOperator = userRole === EUserRole.Operator

    const isAdmin = userRole === EUserRole.Administrator || userRole === EUserRole.SuperAdmin

    return (
        <div className={style.headerMain}>
            <div className={style.guestDesktopOnly}>
                <ExternalNavigation />
            </div>
            <Divider className={style.guestDesktopOnly} style={{ margin: '0' }} />
            <div className={style.container}>
                {!isAuth ? (
                    <>
                        <div className={style.guestDesktopOnly}>
                            <Navigation />
                        </div>
                        <div className={style.guestMobileOnly}>
                            <Link to="main" className={style.logo}>
                                <LogoGreenETrack />
                            </Link>
                            <MobileGuestMenu />
                        </div>
                    </>
                ) : (
                    !isUserLoading && (
                        <>
                            {!isUserLoading && (isAdmin || isOperator) ? (
                                <AdminNavigation isAdmin={isAdmin} />
                            ) : (
                                <Navigation />
                            )}
                        </>
                    )
                )}
                <div className={style.headerAuth}>
                    <div className={style.guestDesktopOnly}>
                        <LanguageMenu />
                    </div>
                    <div className={`${style.separator} ${style.guestDesktopOnly}`} />
                    <div className={!isAuth ? style.guestDesktopOnly : undefined}>
                        <UserPanel isAdminOrOperator={isAdmin || isOperator} isUnread={isUnread} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header
